module.exports = __webpack_public_path__ + "img/data_lock_icon.e750d1b6.svg";